
import { Button } from "./ui/button.tsx";
import { Menu, X } from "lucide-react";
import { useState } from "react";

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex justify-between items-center h-16">
                <div className="flex-shrink-0"> <a href="/">
                <img src="/img/logo_EGMG.jpg" alt="esgehtmirgut.ch"  style={{height: 4.0 + "rem"}} /></a>
                </div>

                {/* Desktop Menu */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
                <a href="/">
              <button
                className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors"
              >
                Home
              </button></a>
              <a href="/login">
              <button
                className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors"
              >
                Mein Profil
              </button></a>
              <a href="/#about">
              <button
                className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors"
              >
                So funktioniert es
              </button></a>
              <a href="/blog">
              <button
                className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors"
              >
                Blog
              </button></a>
              <a href="/#contact">
              <button
                className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors"
              >
                Kontakt
              </button></a>
            </div>
          </div>

            <div className="hidden md:block">
                <a href="./register">
                    <Button className="bg-blue-600 hover:bg-blue-700 text-white">
                    Jetzt starten
                    </Button>
                </a>
            </div>

                  {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-blue-600 p-2"
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t">
                <a href="/">
              <button
                className="text-gray-700 hover:text-blue-600 block px-3 py-2 text-base font-medium w-full text-left"
              >
                Home
              </button></a>
              <a href="/login">
              <button
                className="text-gray-700 hover:text-blue-600 block px-3 py-2 text-base font-medium w-full text-left"
              >
                Mein Profil
              </button></a>
              <a href="/#about">
              <button
                className="text-gray-700 hover:text-blue-600 block px-3 py-2 text-base font-medium w-full text-left"
              >
                So funktioniert es
              </button></a>
              <a href="/blog">
              <button
                className="text-gray-700 hover:text-blue-600 block px-3 py-2 text-base font-medium w-full text-left"
              >
                Blog
              </button></a>
              <a href="/#contact">
              <button
                className="text-gray-700 hover:text-blue-600 block px-3 py-2 text-base font-medium w-full text-left"
              >
                Kontakt
              </button></a>
              <div className="px-3 py-2">
              <a href="./register">
                <Button className="bg-blue-600 hover:bg-blue-700 text-white w-full">
                  Jetzt starten
                </Button>
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;